<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保养计划标识" prop="planId">
              <!-- <a-input-number placeholder="请选择保养计划" style="width: 100%" v-model="model.planId" /> -->
              <j-select-device-plan
                :multiple="false"
                @select="planSelect"
                placeholder="请选择保养计划"
                v-model="model.planId"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务单号" prop="taskCode">
              <a-input placeholder="请输入任务单号" v-model="model.taskCode"></a-input>
            </a-form-model-item>
          </a-col>-->
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务完成人" prop="finishId">
              <a-input placeholder="请输入任务完成人" v-model="model.finishId"></a-input>
            </a-form-model-item>
          </a-col>-->
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务完成人名称" prop="finishName">
              <a-input placeholder="请输入任务完成人名称" v-model="model.finishName"></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划执行时间" prop="planTime">
              <j-date placeholder="请选择计划执行时间" style="width: 100%" v-model="model.planTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际执行时间" prop="realTime">
              <j-date placeholder="请选择实际执行时间" style="width: 100%" v-model="model.realTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="养护过程" prop="content">
              <a-input placeholder="请输入养护过程" v-model="model.content"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件" prop="pictures">
              <!-- <a-input placeholder="请输入附件" v-model="model.pictures"></a-input> -->
              <j-upload v-model="model.pictures"></j-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务状态" prop="taskStatus">
              <!-- <a-input-number placeholder="请输入任务状态(0待进行,1进行中,2已完成)" style="width: 100%" v-model="model.taskStatus" /> -->
              <j-dict-select-tag
                :showPlease="false"
                dictCode="dev_maintaince_task_status"
                placeholder="请选择任务状态"
                v-model="model.taskStatus"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="租户标识" prop="tenantId">
              <a-input placeholder="请输入租户标识" v-model="model.tenantId"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司标识" prop="orgId">
              <a-input placeholder="请输入公司标识" v-model="model.orgId"></a-input>
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JSelectDevicePlan from '../../../components/jeecgbiz/JSelectDevicePlan.vue'

  export default {
    name: 'DevMaintainceTaskForm',
    components: {
      JSelectDevicePlan
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/maintenance/devMaintainceTask/add",
          edit: "/maintenance/devMaintainceTask/edit",
          queryById: "/maintenance/devMaintainceTask/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      planSelect (rows) {
        this.model.planName = rows[0].planName
      }
    }
  }
</script>